import { Box, Grid, IconButton, Input, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { useState } from "react";
import { useDebounce } from "use-debounce";
import { SharedCollectibles, SharedHighlights } from "../../../components";
import { LessonsInCollectibles } from "../../components/lessons-in-collectibles/lessons-in-collectibles.component";
import { useStyles } from "./collectibles-tab.styles";

export const CollectiblesTab = () => {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState("");
  const [searchTerm] = useDebounce(searchValue, 1000);

  const handleSearchChange = (event) =>
    setSearchValue(event?.target?.value || "");

  return (
    <Grid container>
      <Grid item md={12} className={classes.searchBar}>
        <Typography className={classes.searchTitle}>
          All Collectibles
        </Typography>
        <Box id="search">
          <Input
            value={searchValue}
            className={classes.searchField}
            onChange={handleSearchChange}
            placeholder="Search"
            endAdornment={
              <IconButton onClick={handleSearchChange}>
                <Close />
              </IconButton>
            }
          />
        </Box>
      </Grid>
      <SharedHighlights hideOnEmptyFilterResult filterBy={searchTerm} />
      <SharedCollectibles hideOnEmptyFilterResult filterBy={searchTerm} />
      <LessonsInCollectibles hideOnEmptyFilterResult filterBy={searchTerm} />
    </Grid>
  );
};
